import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

import { SessionService } from '../auth/session.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const session = inject(SessionService);
  const router = inject(Router);

  if (session.getCurrentUser()) {
    return true;
  }

  if (!environment.production) {
    console.warn('[authGuard] missing currentUser -> redirect to /login', {
      attempted_url: state.url,
    });
  }

  return router.createUrlTree(['/login'], {
    queryParams: {
      returnUrl: state.url
    }
  });
};
